import React from "react";
import { Col } from "antd";
import "./style.css";

const Disclaimer = () => {
  return (
    <>
      <Col>
        <Col offset={2} span={20} className="mt-3">
          <h2 className="mt-3"><center>CRP Menu Tool - Disclaimer</center></h2>
        </Col>
      </Col>
      <Col>
        <h3>Interpretation and Definitions</h3>
        <h4>Interpretation</h4>
        <p>
          The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </p>
        <h4>Definitions</h4>
        <p>
          For the purposes of this Disclaimer:
          <p>
            •	<b>University</b> (referred to as either "the University", "We", "Us" or "Our" in this Disclaimer) refers to Mississippi State University, 75 B. S. Hood Rd, Mississippi State, MS 39762.
          </p>
          <p>
            •	<b>Service</b> refers to the Website.
          </p>
          <p>
            •	<b>You</b> means the individual accessing the Service, or the University, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
          </p>
          <p>
            •	<b>Website</b> refers to CRP Menu Tool, accessible from https://crpmenu.gri.msstate.edu/
          </p>
        </p>
        <h3>Disclaimer</h3>
        <p>
          The information contained on the Service is for general information purposes only.
          The University assumes no responsibility for errors or omissions in the contents of the Service.
          In no event shall the University be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The University reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice. This Disclaimer has been created with the help of the Disclaimer Generator.
          The University does not warrant that the Service is free of viruses or other harmful components.
        </p>
        <h3>External Links Disclaimer</h3>
        <p>
          The Service may contain links to external websites that are not provided or maintained by or in any way affiliated with the University.
          Please note that the University does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
          Errors and Omissions Disclaimer
          The information given by the Service is for general guidance on matters of interest only. Even if the University takes every precaution to ensure that the content of the Service is both current and accurate, errors can occur. Plus, given the changing nature of laws, rules and regulations, there may be delays, omissions or inaccuracies in the information contained on the Service.
          The University is not responsible for any errors or omissions, or for the results obtained from the use of this information.
        </p>
        <h3>Fair Use Disclaimer</h3>
        <p>
          The University may use copyrighted material which has not always been specifically authorized by the copyright owner. The University is making such material available for criticism, comment, news reporting, teaching, scholarship, or research.
          The University believes this constitutes a "fair use" of any such copyrighted material as provided for in section 107 of the United States Copyright law.
          If You wish to use copyrighted material from the Service for your own purposes that go beyond fair use, You must obtain permission from the copyright owner.
        </p>
        <h3>Views Expressed Disclaimer</h3>
        <p>
          The Service may contain views and opinions which are those of the authors and do not necessarily reflect the official policy or position of any other author, agency, organization, employer or University, including the University.
          Comments published by users are their sole responsibility and the users will take full responsibility, liability and blame for any libel or litigation that results from something written in or as a direct result of something written in a comment. The University is not liable for any comment published by users and reserves the right to delete any comment for any reason whatsoever.
        </p>
        <h3>No Responsibility Disclaimer</h3>
        <p>
          The information on the Service is provided with the understanding that the University is not herein engaged in rendering legal, accounting, tax, or other professional advice and services. As such, it should not be used as a substitute for consultation with professional accounting, tax, legal or other competent advisers.
          In no event shall the University or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access or use or inability to access or use the Service.
        </p>
        <h3>"Use at Your Own Risk" Disclaimer</h3>
        <p>
          All information in the Service is provided "as is", with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind, express or implied, including, but not limited to warranties of performance, merchantability and fitness for a particular purpose.
          The University will not be liable to You or anyone else for any decision made or action taken in reliance on the information given by the Service or for any consequential, special or similar damages, even if advised of the possibility of such damages.
        </p>
        <h3>Contact Us</h3>
        <p>
          If you have any questions about this Disclaimer, You can contact us by visiting this page on our website: https://crpmenu.gri.msstate.edu/Contact
        </p>
      </Col>
    </>
  );
};

export default Disclaimer;
